import { Box, Grid, Typography, useTheme } from "@mui/material";

import { FC } from "react";
import {
	ITest,
} from "@websential/cosmic-v20";
import { Link } from "react-router-dom";

interface INetSuiteSetupFieldsRightPanel { }
export const NetSuiteSetupFieldsRightPanel: FC<
	INetSuiteSetupFieldsRightPanel
> = ({ }) => {
	const theme = useTheme();
	return (
		<>
			<Box>
				<Typography sx={{
					marginBottom: "10px"
				}}>
					Connection point url for auto login from netsuite.
				</Typography>
				<Typography sx={{
					marginBottom: "10px",
					wordBreak: "break-word",
					overflowWrap: "break-word",
				}}>
					https://www.simplepay.ca/canada_payroll/admin/Accounting_Setup/netsuite/single_signon/index.php?usertoken=ba4508d7be18cd918de9d30eb63329b1
				</Typography>
				<Link
					to={`#`}
					className="no-underline"
					style={{ color: theme.palette.primary.light }}
				>
					Click here
				</Link>
				&nbsp;&nbsp; <span style={{ fontSize: ".875rem" }}>
					to re- generate Url.
				</span>
				&nbsp;&nbsp;
			</Box>
		</>
	);
};
